import React from "react";
import { useTranslation } from "react-i18next";
import { Profile } from "../../../types/types";
import { safeExternalUrl } from "../../../utils/safeHtml";

interface SponsorshipsProps {
  member: Profile;
}

const Sponsorships: React.FC<SponsorshipsProps> = ({ member }) => {
  const { t } = useTranslation("publicProfile");
  if (!member.fighter) return null;

  const sponsors = member.fighter?.sponsorsResponseDtos ?? [];

  return (
    <div
      className="flex flex-col items-center gap-6 pt-6 pb-8"
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      <h3 className="text-center text-sm font-medium text-gray-900">
        {t("sponsorships")}
      </h3>

      {sponsors.length > 0 ? (
        <div className="w-full max-w-[1220px] flex flex-wrap justify-around items-center gap-x-10 gap-y-8 px-4 lg:px-8">
          {sponsors.map((sponsor) => {
            const body = sponsor.logo ? (
              <img
                src={sponsor.logo}
                alt={sponsor.name}
                title={sponsor.name}
                className="h-20 sm:h-28 lg:h-32 w-auto max-w-[160px] sm:max-w-[220px] object-contain"
              />
            ) : (
              <span className="text-base sm:text-xl font-extrabold text-gray-900 tracking-wide uppercase text-center">
                {sponsor.name}
              </span>
            );

            const sponsorUrl = safeExternalUrl(sponsor.link);

            return sponsorUrl ? (
              <a
                key={sponsor.id}
                href={sponsorUrl}
                target="_blank"
                rel="noopener noreferrer"
                title={sponsor.link}
                className="hover:opacity-80 transition-opacity"
              >
                {body}
              </a>
            ) : (
              <div key={sponsor.id}>{body}</div>
            );
          })}
        </div>
      ) : (
        <p className="text-gray-400 text-xs text-center py-4">{t("no_sponserships")}</p>
      )}
    </div>
  );
};

export default Sponsorships;